<template>
  <span>{{getValueSting}}</span>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'Dict',
  props: {
    code: { // 字典表对应的key
      type: String,
      require: true
    },
    value: { // 字典表对应的key
      type: [String, Number],
      require: true
    },
    abbr: { // 是否是简称模式,简称模式下直接显示简称
      type: Boolean,
      default: false
    },
    empty: { // 控制显示的内容，例如'-'
      type: String
    }
  },
  data() {
    return {};
  },
  watch: {},
  computed: {
    ...mapGetters(['dictMap']),
    getValueSting() {
      let dict_str = this.empty || '';
      if (this.dictMap[this.code] && (this.value || this.isZero(this.value))) {
        const options = this.dictMap[this.code].options;
        options.map((item, index) => {
          if (item.value.toLowerCase() == this.value.toLowerCase()) {
            if (this.abbr) {
              dict_str = item.abbreviation;
            } else {
              dict_str = this.$languageChoose({
                zh: item.text,
                en: item.textEn
              });
            }
          }
        });
      }
      return dict_str;
    }
  },
  created() {
    if (!this.dictMap[this.code]) {
      this.initDictData();
    }
  },
  methods: {
    // 获取字典数据
    initDictData() {
      // 根据字典Code, 初始化字典数组
      this.$getDictionary(this.code).then(res => {
      });
    },
    isZero(str) {
      return (str == '0') || (str == 0);
    }
  },
  mounted() {
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// Dict.vue?0693e935